<template>
  <div>
    <h2 class="text-1xl font-bold text-gray-700">
      Modulo para comparar precio entre proveedores
    </h2>
    <MainComparePriceBetweenProviders />
  </div>
</template>

<script>
import MainComparePriceBetweenProviders from "@/components/Reports/ComparePriceBetweenProviders/MainComparePriceBetweenProviders.vue";
import { useRoute } from "vue-router";
import { onBeforeMount, onMounted } from "vue";
import { findSubmoduleIdByDescription } from "@/hisAcces";
export default {
  name: "ComparePriceBetweenProviders",
  components: {
    MainComparePriceBetweenProviders,
  },
  setup() {
    const route = useRoute();
    onBeforeMount(() => {
      if (!findSubmoduleIdByDescription(route.path)) {
        window.location.href = "/login";
      }
    });

    onMounted(() => {
      document.title =
        route.meta.title + process.env.VUE_APP_TITLE ||
        process.env.VUE_APP_TITLE;
    });
  },
};
</script>
